import {useEffect, useState} from "react"
import { connect } from "react-redux"
import DeleteIcon from '@mui/icons-material/Delete';
import CurrencyFormatter from "currency-formatter";
import BVAInput from "../../../../components/BVAInput/BVAInput";
import {
  addCustomFieldToStockSaleProceedsWorksheet,
  generateOwnerFinancingStockSaleReport, updateCustomFieldOnStockSaleProceedsWorksheet,
  updateOwnerFinancingStockSaleReport
} from "../../../../store/modules/financials/actions";
import BVAButton from "../../../../components/BVAButton/BVAButton";
import {Divider} from "@mui/material";
import CustomField from "../../../../models/CustomField";


function OwnerFinancingStockSaleProceedsWorksheet({
  appState,
  ownerFinancingStockSaleReport,
  dispatchGenerateOwnerFinancingStockSaleReport,
  dispatchUpdateOwnerFinancingStockSaleReport,
  dispatchAddCustomFieldToStockSaleProceedsWorksheet,
  dispatchUpdateCustomFieldOnStockSaleProceedsWorkSheet
}) {
  // Watcher
  useEffect(() => {
    dispatchGenerateOwnerFinancingStockSaleReport()
  }, [])

  // Methods
  const handleSellingExpensesOnChange = (key, value) => {
    dispatchUpdateOwnerFinancingStockSaleReport({
      sellingExpenses: {
        [key]: value
      }
    })
  }

  const handleAccountsPayableOnChange = (key, value) => {
    dispatchUpdateOwnerFinancingStockSaleReport({
      accountsPayable: {
        [key]: value
      }
    })
  }

  const handleOtherExpensesNeededToCloseOnChange = (key, value) => {
    dispatchUpdateOwnerFinancingStockSaleReport({
      otherExpensesNeededToClose: {
        [key]: value
      }
    })
  }

  const handleTotalCurrentAssetsKeptBySellerOnChange = (key, value) => {
    dispatchUpdateOwnerFinancingStockSaleReport({
      totalCurrentAssetsKeptBySeller: {
        [key]: value
      }
    })
  }


  const handleExistingLiabilitiesAssumedByBuyerOnChange = (key, value) => {
    dispatchUpdateOwnerFinancingStockSaleReport({
      existingLiabilitiesAssumedByBuyer: {
        [key]: value
      }
    })
  }


  const handleCustomFieldOnCreation = (section) => {
    dispatchAddCustomFieldToStockSaleProceedsWorksheet({ section })
  }

  const handleCustomFieldValueOnUpdate = ({ section, index, name, value }) => {
    const customFields = ownerFinancingStockSaleReport[section].customFields.map((customField, _index) => {
      if (_index === index) {
        const _customField = { ...customField }
        if (name || name === "") _customField.name = name
        if (value || value === 0) _customField.value = CurrencyFormatter.unformat(value, { code: "USD" })

        return _customField
      }

      return customField
    })

    dispatchUpdateCustomFieldOnStockSaleProceedsWorkSheet({ section, customFields })
  }

  const handleDeleteCustomField = ({ section, index }) => {
    const customFields = ownerFinancingStockSaleReport[section].customFields.filter((customField, _index) => {
      if (_index === index) return false

      return true
    })

    dispatchUpdateCustomFieldOnStockSaleProceedsWorkSheet({ section, customFields })
  }

  const longTermAssetsKeptBySellerHasItems = () => {
    return (
      ownerFinancingStockSaleReport?.longTermAssetsKeptBySeller?.customFields?.length > 0
      || ownerFinancingStockSaleReport?.longTermAssetsKeptBySeller?.longTermAssets?.length > 0
    )
  }

  const handleProceedsSummaryCustomField = (customFieldKey, customFieldAttribute, customFieldValue) => {
    let customField = null
    let _customFieldValue = customFieldValue
    if (customFieldAttribute === "value") {
      _customFieldValue = CurrencyFormatter.unformat(customFieldValue, { code: "USD" })
    }

    if (customFieldKey === "customFieldToAdd") {
      customField = new CustomField({
        ...ownerFinancingStockSaleReport.customFieldToAdd,
        [customFieldAttribute]: _customFieldValue
      })
    }
    if (customFieldKey === "customFieldToSubtract") {
      customField = new CustomField({
        ...ownerFinancingStockSaleReport?.customFieldToSubtract,
        [customFieldAttribute]: _customFieldValue
      })
    }

    dispatchUpdateOwnerFinancingStockSaleReport({ [customFieldKey]: customField })
  }


  return (
    <>
      <section className="py-0">
        <div className="mt-10 flex justify-center">
          <div className="w-full max-w-2xl mr-10">
            <h2 className="text-center font-bold text-xl">Cash at Closing Estimate</h2>
            <div className="mt-10 border p-5 rounded-lg bg-neutral-200 flex items-center justify-between">
              <label className="font-semibold">1. Cash Down Payment</label>
              <label className="font-semibold">{ownerFinancingStockSaleReport?.cashDownPaymentFormatted}</label>
            </div>
            <div className="mt-10">
              <h3 className="px-4 font-semibold text-lg">2. Selling Expenses</h3>
              <div className="mt-2 border p-5 rounded-lg">
                <div className="flex justify-between items-center">
                  <label>Brokerage Fees</label>
                  <div className="flex items-center">
                    <BVAInput
                      size="small"
                      textAlign="end"
                      value={ownerFinancingStockSaleReport?.sellingExpenses?.brokerageFees}
                      onChange={(value) => handleSellingExpensesOnChange("brokerageFees", value)} />
                    <div className="ml-2">
                      <BVAButton disabled shape="circle" iconButton icon={{ url: DeleteIcon }} />
                    </div>
                  </div>
                </div>
                <div className="flex justify-between items-center mt-2">
                  <label>Filings & Recordings</label>
                  <div className="flex items-center">
                    <BVAInput
                      size="small"
                      textAlign="end"
                      value={ownerFinancingStockSaleReport?.sellingExpenses?.filingsAndRecordings}
                      onChange={(value) => handleSellingExpensesOnChange("filingsAndRecordings", value)} />
                    <div className="ml-2">
                      <BVAButton disabled shape="circle" iconButton icon={{ url: DeleteIcon }} />
                    </div>
                  </div>
                </div>
                <div className="flex justify-between items-center mt-2">
                  <label>Attorney's Fees</label>
                  <div className="flex items-center">
                    <BVAInput
                      size="small"
                      textAlign="end"
                      value={ownerFinancingStockSaleReport?.sellingExpenses?.attorneyFees}
                      onChange={(value) => handleSellingExpensesOnChange("attorneyFees", value)} />
                    <div className="ml-2">
                      <BVAButton disabled shape="circle" iconButton icon={{ url: DeleteIcon }} />
                    </div>
                  </div>
                </div>
                <div className="flex justify-between items-center mt-2">
                  <label>Accountant's Fees</label>
                  <div className="flex items-center">
                    <BVAInput
                      size="small"
                      textAlign="end"
                      value={ownerFinancingStockSaleReport?.sellingExpenses?.accountantFees}
                      onChange={(value) => handleSellingExpensesOnChange("accountantFees", value)} />
                    <div className="ml-2">
                      <BVAButton disabled shape="circle" iconButton icon={{ url: DeleteIcon }} />
                    </div>
                  </div>
                </div>
                <div className="flex justify-between items-center mt-2">
                  <label>Escrow Fees</label>
                  <div className="flex items-center">
                    <BVAInput
                      size="small"
                      textAlign="end"
                      value={ownerFinancingStockSaleReport?.sellingExpenses?.escrowFees}
                      onChange={(value) => handleSellingExpensesOnChange("escrowFees", value)} />
                    <div className="ml-2">
                      <BVAButton disabled shape="circle" iconButton icon={{ url: DeleteIcon }} />
                    </div>
                  </div>
                </div>
                {ownerFinancingStockSaleReport?.sellingExpenses?.customFields.map((customField, index) => (
                    <div className="flex justify-between items-center mt-2">
                      <BVAInput
                        value={customField?.name}
                        placeholder="Item name"
                        type="text"
                        size="small"
                        onChange={(value) => handleCustomFieldValueOnUpdate({
                          section: "sellingExpenses",
                          index,
                          name: value
                        })}/>
                      <div className="flex items-center">
                        <BVAInput
                          size="small"
                          textAlign="end"
                          value={customField?.value}
                          onChange={(value) => handleCustomFieldValueOnUpdate({
                            section: "sellingExpenses",
                            index,
                            value
                          })} />
                        <div className="ml-2">
                          <BVAButton
                          shape="circle"
                          iconButton
                          icon={{ url: DeleteIcon }}
                          onClick={() => handleDeleteCustomField({ section: "sellingExpenses", index })} />
                        </div>
                      </div>
                    </div>
                ))}
                <div className="mt-10 flex justify-center border rounded p-5">
                  <BVAButton
                    kind="primary-outlined"
                    slimHeight
                    onClick={() => handleCustomFieldOnCreation("sellingExpenses")}>
                    Add Item
                  </BVAButton>
                </div>
              </div>
              <div className="mt-4 border p-5 rounded-lg bg-neutral-100 flex items-center justify-between">
                <label>Total Selling Expenses</label>
                <label>{ownerFinancingStockSaleReport?.sellingExpenses?.totalSellingExpensesFormatted}</label>
              </div>
            </div>
            <div className="mt-10">
              <h3 className="px-4 font-semibold text-lg">3. Accounts Payable (Not Assumed by Purchaser)</h3>
              <div className="mt-2 border p-5 rounded-lg">
                <div className="flex justify-between items-center">
                  <label>Payroll Payables </label>
                  <div className="flex items-center">
                    <BVAInput
                      size="small"
                      textAlign="end"
                      value={ownerFinancingStockSaleReport?.accountsPayable?.payrollPayables}
                      onChange={(value) => handleAccountsPayableOnChange("payrollPayables", value)} />
                    <div className="ml-2">
                      <BVAButton disabled shape="circle" iconButton icon={{ url: DeleteIcon }} />
                    </div>
                  </div>
                </div>
                <div className="flex justify-between items-center mt-2">
                  <label>Sales Tax Payables</label>
                  <div className="flex items-center">
                    <BVAInput
                      size="small"
                      textAlign="end"
                      value={ownerFinancingStockSaleReport?.accountsPayable?.salesTaxPayables}
                      onChange={(value) => handleAccountsPayableOnChange("salesTaxPayables", value)} />
                    <div className="ml-2">
                      <BVAButton disabled shape="circle" iconButton icon={{ url: DeleteIcon }} />
                    </div>
                  </div>
                </div>
                {ownerFinancingStockSaleReport?.accountsPayable?.customFields.map((customField, index) => (
                  <div className="flex justify-between items-center mt-2">
                    <BVAInput
                      value={customField?.name}
                      placeholder="Item name"
                      type="text"
                      size="small"
                      onChange={(value) => handleCustomFieldValueOnUpdate({
                        section: "accountsPayable",
                        index,
                        name: value
                      })}/>
                    <div className="flex items-center">
                      <BVAInput
                        size="small"
                        textAlign="end"
                        value={customField?.value}
                        onChange={(value) => handleCustomFieldValueOnUpdate({
                          section: "accountsPayable",
                          index,
                          value
                        })} />
                      <div className="ml-2">
                        <BVAButton
                          shape="circle"
                          iconButton
                          icon={{ url: DeleteIcon }}
                          onClick={() => handleDeleteCustomField({ section: "accountsPayable", index })} />
                      </div>
                    </div>
                  </div>
                ))}
                <div className="mt-10 flex justify-center border rounded p-5">
                  <BVAButton
                    kind="primary-outlined"
                    slimHeight
                    onClick={() => handleCustomFieldOnCreation("accountsPayable")}>
                    Add Item
                  </BVAButton>
                </div>
              </div>
              <div className="mt-4 border p-5 rounded-lg bg-neutral-100 flex items-center justify-between">
                <label>Total Accounts Payable</label>
                <label>{ownerFinancingStockSaleReport?.accountsPayable?.totalAccountsPayableFormatted}</label>
              </div>
            </div>
            <div className="mt-10">
              <h3 className="px-4 font-semibold text-lg">4. Long Term Debt (Not Assumed by Purchaser)</h3>
              <div className="mt-2 border p-5 rounded-lg">
                {ownerFinancingStockSaleReport?.longTermDebtNotAssumedByBuyer?.longTermDebt?.map((longTermDebt) => (
                  <div className="flex justify-between items-center mb-2 last:mb-0">
                    <label>{longTermDebt?.name}</label>
                    <label>{longTermDebt?.amountFormatted}</label>
                  </div>
                ))}
                {ownerFinancingStockSaleReport?.longTermDebtNotAssumedByBuyer?.customFields.map((customField, index) => (
                  <div className="flex justify-between items-center mt-2">
                    <BVAInput
                      value={customField?.name}
                      placeholder="Item name"
                      type="text"
                      size="small"
                      onChange={(value) => handleCustomFieldValueOnUpdate({
                        section: "longTermDebtNotAssumedByBuyer",
                        index,
                        name: value
                      })}/>
                    <div className="flex items-center">
                      <BVAInput
                        size="small"
                        textAlign="end"
                        value={customField?.value}
                        onChange={(value) => handleCustomFieldValueOnUpdate({
                          section: "longTermDebtNotAssumedByBuyer",
                          index,
                          value
                        })} />
                      <div className="ml-2">
                        <BVAButton
                          shape="circle"
                          iconButton
                          icon={{ url: DeleteIcon }}
                          onClick={() => handleDeleteCustomField({ section: "longTermDebtNotAssumedByBuyer", index })}  />
                      </div>
                    </div>
                  </div>
                ))}
                <div className={`${ownerFinancingStockSaleReport?.longTermDebtNotAssumedByBuyer?.hasItems ? "mt-10" : ""} 
              flex justify-center border rounded p-5`}>
                  <BVAButton
                    kind="primary-outlined"
                    slimHeight
                    onClick={() => handleCustomFieldOnCreation("longTermDebtNotAssumedByBuyer")}>
                    Add Item
                  </BVAButton>
                </div>
              </div>
              <div className="mt-4 border p-5 rounded-lg bg-neutral-100 flex items-center justify-between">
                <label>Total Long Term Debt</label>
                <label>{ownerFinancingStockSaleReport?.longTermDebtNotAssumedByBuyer?.totalLongTermDebtFormatted}</label>
              </div>
            </div>
            <div className="mt-10">
              <h3 className="px-4 font-semibold text-lg">5. Other Expenses Needed to Close</h3>
              <div className="mt-2 border p-5 rounded-lg">
                <div className="flex justify-between items-center">
                  <label>Equipment Repair</label>
                  <div className="flex items-center">
                    <BVAInput
                      size="small"
                      textAlign="end"
                      value={ownerFinancingStockSaleReport?.otherExpensesNeededToClose?.equipmentRepair}
                      onChange={(value) => handleOtherExpensesNeededToCloseOnChange("equipmentRepair", value)} />
                    <div className="ml-2">
                      <BVAButton disabled shape="circle" iconButton icon={{ url: DeleteIcon }} />
                    </div>
                  </div>
                </div>
                <div className="flex justify-between items-center mt-2">
                  <label>Equipment Replace</label>
                  <div className="flex items-center">
                    <BVAInput
                      size="small"
                      textAlign="end"
                      value={ownerFinancingStockSaleReport?.otherExpensesNeededToClose?.equipmentReplace}
                      onChange={(value) => handleOtherExpensesNeededToCloseOnChange("equipmentReplace", value)} />
                    <div className="ml-2">
                      <BVAButton disabled shape="circle" iconButton icon={{ url: DeleteIcon }} />
                    </div>
                  </div>
                </div>
                <div className="flex justify-between items-center mt-2">
                  <label>Compliance with Governmental Agencies</label>
                  <div className="flex items-center">
                    <BVAInput
                      size="small"
                      textAlign="end"
                      value={ownerFinancingStockSaleReport?.otherExpensesNeededToClose?.complianceWithGovernmentalAgencies}
                      onChange={(value) => handleOtherExpensesNeededToCloseOnChange("complianceWithGovernmentalAgencies", value)} />
                    <div className="ml-2">
                      <BVAButton disabled shape="circle" iconButton icon={{ url: DeleteIcon }} />
                    </div>
                  </div>
                </div>
                {ownerFinancingStockSaleReport?.otherExpensesNeededToClose?.customFields.map((customField, index) => (
                  <div className="flex justify-between items-center mt-2">
                    <BVAInput
                      value={customField?.name}
                      placeholder="Item name"
                      type="text"
                      size="small"
                      onChange={(value) => handleCustomFieldValueOnUpdate({
                        section: "otherExpensesNeededToClose",
                        index,
                        name: value
                      })}/>
                    <div className="flex items-center">
                      <BVAInput
                        size="small"
                        textAlign="end"
                        value={customField?.value}
                        onChange={(value) => handleCustomFieldValueOnUpdate({
                          section: "otherExpensesNeededToClose",
                          index,
                          value
                        })} />
                      <div className="ml-2">
                        <BVAButton
                          shape="circle"
                          iconButton
                          icon={{ url: DeleteIcon }}
                          onClick={() => handleDeleteCustomField({ section: "otherExpensesNeededToClose", index })}  />
                      </div>
                    </div>
                  </div>
                ))}
                <div className="mt-10 flex justify-center border rounded p-5">
                  <BVAButton
                    kind="primary-outlined"
                    slimHeight
                    onClick={() => handleCustomFieldOnCreation("otherExpensesNeededToClose")}>
                    Add Item
                  </BVAButton>
                </div>
              </div>
              <div className="mt-4 border p-5 rounded-lg bg-neutral-100 flex items-center justify-between">
                <label>Total Other Expenses</label>
                <label>{ownerFinancingStockSaleReport?.otherExpensesNeededToClose?.totalOtherExpensesNeededToCloseFormatted}</label>
              </div>
            </div>
            <div className="mt-10 border p-5 rounded-lg bg-neutral-200 flex items-center justify-between">
              <label className="font-semibold">6. Total Sales Expenses and Other</label>
              <label className="font-semibold">
                {ownerFinancingStockSaleReport?.totalSalesAndOtherExpensesFormatted}
              </label>
            </div>
            <div className="mt-10 border p-5 rounded-lg bg-neutral-200 flex items-center justify-between">
              <label className="font-semibold">7. Net Cash after Liabilities and Selling Expenses</label>
              <label className="font-semibold">
                {ownerFinancingStockSaleReport?.netCashAfterLiabilitiesAndSellingExpensesFormatted}
              </label>
            </div>
            <div className="mt-10">
              <h3 className="px-4 font-semibold text-lg">8. Total Current Assets Kept By Seller</h3>
              <div className="mt-2 border p-5 rounded-lg">
                {ownerFinancingStockSaleReport?.totalCurrentAssetsKeptBySeller?.currentAssets?.map((currentAsset) => (
                  <div className="flex justify-between items-center mt-2">
                    <label>{currentAsset?.name}</label>
                    <div className="flex items-center">
                      <label>{currentAsset?.amountFormatted}</label>
                      <div className="ml-2">
                        <BVAButton disabled shape="circle" iconButton icon={{ url: DeleteIcon }} />
                      </div>
                    </div>
                  </div>
                ))}
                <div className="flex justify-between items-center mt-2">
                  <label>Return of Lease Deposit</label>
                  <div className="flex items-center">
                    <BVAInput
                      size="small"
                      textAlign="end"
                      value={ownerFinancingStockSaleReport?.totalCurrentAssetsKeptBySeller?.returnOfLeaseDeposit}
                      onChange={(value) => handleTotalCurrentAssetsKeptBySellerOnChange("returnOfLeaseDeposit", value)} />
                    <div className="ml-2">
                      <BVAButton disabled shape="circle" iconButton icon={{ url: DeleteIcon }} />
                    </div>
                  </div>
                </div>
                <div className="flex justify-between items-center mt-2">
                  <label>Petty Cash</label>
                  <div className="flex items-center">
                    <BVAInput
                      size="small"
                      textAlign="end"
                      value={ownerFinancingStockSaleReport?.totalCurrentAssetsKeptBySeller?.pettyCash}
                      onChange={(value) => handleTotalCurrentAssetsKeptBySellerOnChange("pettyCash", value)} />
                    <div className="ml-2">
                      <BVAButton disabled shape="circle" iconButton icon={{ url: DeleteIcon }} />
                    </div>
                  </div>
                </div>
                <div className="flex justify-between items-center mt-2">
                  <label>Prorated Rent</label>
                  <div className="flex items-center">
                    <BVAInput
                      size="small"
                      textAlign="end"
                      value={ownerFinancingStockSaleReport?.totalCurrentAssetsKeptBySeller?.proratedRent}
                      onChange={(value) => handleTotalCurrentAssetsKeptBySellerOnChange("proratedRent", value)} />
                    <div className="ml-2">
                      <BVAButton disabled shape="circle" iconButton icon={{ url: DeleteIcon }} />
                    </div>
                  </div>
                </div>
                <div className="flex justify-between items-center mt-2">
                  <label>Utility Deposit</label>
                  <div className="flex items-center">
                    <BVAInput
                      size="small"
                      textAlign="end"
                      value={ownerFinancingStockSaleReport?.totalCurrentAssetsKeptBySeller?.utilityDeposit}
                      onChange={(value) => handleTotalCurrentAssetsKeptBySellerOnChange("utilityDeposit", value)} />
                    <div className="ml-2">
                      <BVAButton disabled shape="circle" iconButton icon={{ url: DeleteIcon }} />
                    </div>
                  </div>
                </div>
                <div className="flex justify-between items-center mt-2">
                  <label>Prorated Taxes</label>
                  <div className="flex items-center">
                    <BVAInput
                      size="small"
                      textAlign="end"
                      value={ownerFinancingStockSaleReport?.totalCurrentAssetsKeptBySeller?.proratedTaxes}
                      onChange={(value) => handleTotalCurrentAssetsKeptBySellerOnChange("proratedTaxes", value)} />
                    <div className="ml-2">
                      <BVAButton disabled shape="circle" iconButton icon={{ url: DeleteIcon }} />
                    </div>
                  </div>
                </div>
                <div className="flex justify-between items-center mt-2">
                  <label>Rebate for Prepaid Expenses</label>
                  <div className="flex items-center">
                    <BVAInput
                      size="small"
                      textAlign="end"
                      value={ownerFinancingStockSaleReport?.totalCurrentAssetsKeptBySeller?.rebateForPrepaidExpenses}
                      onChange={(value) => handleTotalCurrentAssetsKeptBySellerOnChange("rebateForPrepaidExpenses", value)} />
                    <div className="ml-2">
                      <BVAButton disabled shape="circle" iconButton icon={{ url: DeleteIcon }} />
                    </div>
                  </div>
                </div>
                {ownerFinancingStockSaleReport?.totalCurrentAssetsKeptBySeller?.customFields.map((customField, index) => (
                  <div className="flex justify-between items-center mt-2">
                    <BVAInput
                      value={customField?.name}
                      placeholder="Item name"
                      type="text"
                      size="small"
                      onChange={(value) => handleCustomFieldValueOnUpdate({
                        section: "totalCurrentAssetsKeptBySeller",
                        index,
                        name: value
                      })}/>

                    <div className="flex items-center">
                      <BVAInput
                        size="small"
                        textAlign="end"
                        value={customField?.value}
                        onChange={(value) => handleCustomFieldValueOnUpdate({
                          section: "totalCurrentAssetsKeptBySeller",
                          index,
                          value
                        })} />
                      <div className="ml-2">
                        <BVAButton
                          shape="circle"
                          iconButton
                          icon={{ url: DeleteIcon }}
                          onClick={() => handleDeleteCustomField({ section: "totalCurrentAssetsKeptBySeller", index })}  />
                      </div>
                    </div>
                  </div>
                ))}
                <div className="mt-10 flex justify-center border rounded p-5">
                  <BVAButton
                    kind="primary-outlined"
                    slimHeight
                    onClick={() => handleCustomFieldOnCreation("totalCurrentAssetsKeptBySeller")}>
                    Add Item
                  </BVAButton>
                </div>
              </div>
              <div className="mt-4 border p-5 rounded-lg bg-neutral-100 flex items-center justify-between">
                <label>Total Additions to Seller's Cash Proceeds</label>
                <label>{ownerFinancingStockSaleReport?.totalCurrentAssetsKeptBySeller?.totalCurrentAssetsKeptBySellerFormatted}</label>
              </div>
            </div>
            <div className="mt-10 border p-5 rounded-lg bg-neutral-200 flex items-center justify-between">
              <label className="font-semibold">9. Estimated Total Net Cash Proceeds to Seller</label>
              <label className="font-semibold">{ownerFinancingStockSaleReport?.estimatedTotalNetCashProceedsToSellerFormatted}</label>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}


const mapStateToProps = (state) => ({
  ownerFinancingStockSaleReport: state.financials.ownerFinancingStockSaleReport,
  appState: state.appState
})

const mapDispatchToProps = (dispatch) => ({
  dispatchGenerateOwnerFinancingStockSaleReport() {
    dispatch(generateOwnerFinancingStockSaleReport())
  },

  dispatchUpdateOwnerFinancingStockSaleReport({
    sellingExpenses,
    accountsPayable,
    otherExpensesNeededToClose,
    totalCurrentAssetsKeptBySeller,
    existingLiabilitiesAssumedByBuyer,
    customFieldToAdd,
    customFieldToSubtract
  }) {
    dispatch(updateOwnerFinancingStockSaleReport({
      sellingExpenses,
      accountsPayable,
      otherExpensesNeededToClose,
      totalCurrentAssetsKeptBySeller,
      existingLiabilitiesAssumedByBuyer,
      customFieldToAdd,
      customFieldToSubtract
    }))
  },

  dispatchAddCustomFieldToStockSaleProceedsWorksheet({ section }) {
    dispatch(addCustomFieldToStockSaleProceedsWorksheet({ section }))
  },

  dispatchUpdateCustomFieldOnStockSaleProceedsWorkSheet({ section, customFields }) {
    dispatch(updateCustomFieldOnStockSaleProceedsWorksheet({ section, customFields }))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(OwnerFinancingStockSaleProceedsWorksheet)